/**
 * Splits a string at a specific word index
 * @param {string} text - The text to split
 * @param {number} index - The word index to split at
 * @returns {Object} Object with 'before' and 'after' properties containing the split text
 */
export function splitStringAtWordIndex(text, index) {
    if (!text) {
        return { before: "", after: "" };
    }

    const words = text.trim().split(/\s+/);

    return {
        before: words.slice(0, index).join(" "),
        after: words.slice(index).join(" ")
    };
}

/**
 * Splits a string at the first occurrence of a character
 * @param {string} text - The text to split
 * @param {string} character - The character to split on
 * @returns {Object} Object with 'before' and 'after' properties containing the split text
 */
export function splitStringAtFirstOccurrence(text, character) {
    if (!text) {
        return { before: "", after: "" };
    }

    const normalizedText = text.trim();

    if (!character) {
        return { before: normalizedText, after: "" };
    }

    const splitIndex = normalizedText.indexOf(character);

    if (splitIndex === -1) {
        return { before: normalizedText, after: "" };
    }

    return {
        before: normalizedText.slice(0, splitIndex + 1),
        after: normalizedText.slice(splitIndex + 1).trimStart()
    };
}